import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const KeymapColumnSchema = BaseSchema.extend({
  keymap: z.string().uuid(),
  labels: z.array(z.string().uuid()).default([]),
  order: z.number(),
});

export type KeymapColumn = z.infer<typeof KeymapColumnSchema>;

export const KeymapColumnEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: KeymapColumnSchema,
});

export type KeymapColumnEntityQueryResult = z.infer<typeof KeymapColumnEntityQueryResultSchema>;
